/**
 * בסיס ה־API:
 * - ייצור (מוגש מפורט 8000): נתיב יחסי `/api/v1` — אותו מקור, בלי CORS.
 * - פיתוח Vite (5173 / preview 4173): תמיד ישירות ל־`http://<host>:<API_PORT>` — בלי תלות בפרוקסי של Vite
 *   (הפרוקסי נוטה להיכשל ממחשב אחר / הגדרות רשת).
 *
 * אופציונלי: `VITE_API_ORIGIN` או `VITE_API_PORT` ב־`.env.local`
 */
export function getApiBasePath(): string {
  if (typeof window === 'undefined') return '/api/v1'
  const env = import.meta.env.VITE_API_ORIGIN as string | undefined
  if (env?.trim()) {
    return `${env.replace(/\/$/, '')}/api/v1`
  }
  const port = window.location.port
  const host = window.location.hostname
  const apiPort = (import.meta.env.VITE_API_PORT as string | undefined)?.trim() || '8000'
  const isViteClient = port === '5173' || port === '4173'
  if (isViteClient) {
    return `http://${host}:${apiPort}/api/v1`
  }
  return '/api/v1'
}

/** כתובות לבדיקת /health — ב־Vite קודם ישירות ל־API */
export function getHealthCheckUrls(): string[] {
  if (typeof window === 'undefined') return ['/health']
  const env = import.meta.env.VITE_API_ORIGIN as string | undefined
  if (env?.trim()) {
    return [`${env.replace(/\/$/, '')}/health`]
  }
  const origin = window.location.origin
  const port = window.location.port
  const host = window.location.hostname
  const apiPort = (import.meta.env.VITE_API_PORT as string | undefined)?.trim() || '8000'
  const isViteClient = port === '5173' || port === '4173'
  if (isViteClient) {
    return [`http://${host}:${apiPort}/health`, `${origin}/health`]
  }
  return [`${origin}/health`]
}
